module.exports = __webpack_public_path__ + "static/img/brees-2013-slide-6.125a3c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2013-slide-6.jpg
// module id = K7kC
// module chunks = 1